import React from 'react';
import UsersByRole from './UsersByRole';

const Landlords = () => (
  <UsersByRole
    role="LANDLORD"
    title="Landlords"
    subtitle="View and search landlords registered on the platform."
    detailBasePath="/system-admin/landlords"
  />
);

export default Landlords;
